import React from "react";
import MatchCard from "./MatchCard";
import { formatGameDate, formatGameTime } from "../Functions/Formatting";

const RESULT_WIN = "#22c55e";
const RESULT_DRAW = "#eab308";
const RESULT_LOSS = "#ef4444";
const RESULT_PENDING = "var(--border-strong)";

function gameTimestampMs(game) {
  const date = String(game?.game_date || "").slice(0, 10);
  if (!date) return NaN;
  const time = String(game?.game_time || "00:00:00").slice(0, 8);
  const ms = new Date(`${date}T${time}`).getTime();
  return Number.isNaN(ms) ? NaN : ms;
}

/** Pick the next upcoming game, else the most recent past game. */
export function pickHighlightGame(games, now = new Date()) {
  if (!Array.isArray(games) || games.length === 0) return null;

  const nowMs = now.getTime();
  const dated = games
    .map((game) => ({ game, ts: gameTimestampMs(game) }))
    .filter((row) => !Number.isNaN(row.ts));

  if (dated.length === 0) return null;

  const upcoming = dated
    .filter((row) => row.ts >= nowMs)
    .sort((a, b) => a.ts - b.ts);
  if (upcoming.length > 0) {
    return { game: upcoming[0].game, kind: "next" };
  }

  const past = dated
    .filter((row) => row.ts < nowMs)
    .sort((a, b) => b.ts - a.ts);
  if (past.length > 0) {
    return { game: past[0].game, kind: "previous" };
  }

  return null;
}

function resultAccentForTeam(teamId, game) {
  const played =
    game?.team1_score !== null &&
    game?.team2_score !== null &&
    game.team1_score !== undefined &&
    game.team2_score !== undefined;

  if (!teamId || !game || !played) return RESULT_PENDING;

  const isTeam1 = String(game.team1_id) === String(teamId);
  const myScore = Number(isTeam1 ? game.team1_score : game.team2_score) || 0;
  const oppScore = Number(isTeam1 ? game.team2_score : game.team1_score) || 0;

  if (myScore > oppScore) return RESULT_WIN;
  if (myScore < oppScore) return RESULT_LOSS;
  return RESULT_DRAW;
}

function matchStatus(game) {
  return game?.team1_score !== null && game?.team2_score !== null
    ? "played"
    : "unplayed";
}

/**
 * Shows the next (or previous) published game for a team.
 * Renders nothing when there is no game.
 */
function TeamHighlightGame({
  game,
  kind,
  teamId,
  themeColor,
  leagueId,
  leagueName,
}) {
  if (!game) return null;

  const label = kind === "previous" ? "Último partido" : "Próximo partido";

  return (
    <div className="reg-team-highlight">
      <div className="reg-team-highlight-label">{label}</div>
      <MatchCard
        team1={game.team1_name}
        team1Logo={game.team1_logo_url}
        team1KitColors={game.team1_kit_colors}
        team1Score={game.team1_score}
        team2={game.team2_name}
        team2Logo={game.team2_logo_url}
        team2KitColors={game.team2_kit_colors}
        team2Score={game.team2_score}
        time={formatGameTime(game.game_time)}
        date={formatGameDate(game.game_date)}
        status={matchStatus(game)}
        gameID={game.game_id}
        league={leagueId}
        leagueName={leagueName}
        themeColor={themeColor}
        accentColor={resultAccentForTeam(teamId, game)}
      />
    </div>
  );
}

export default TeamHighlightGame;
